import { useEffect, useState } from "react";
import { routes } from "../../general/routes/newsApi";

export default function useNewsAdminServer() {
    const [state, setState] = useState({
        server: routes.Vercel,
        serverResolved: false,
    });

    useEffect(() => {
        const controller = new AbortController();

        async function resolveServer() {
            try {
                const response = await fetch(`${routes.Hostinger}/ping`, { signal: controller.signal });
                const text = await response.text();
                const nextServer = text === "pong" ? routes.Hostinger : routes.Vercel;

                setState({
                    server: nextServer,
                    serverResolved: true,
                });
            } catch {
                setState({
                    server: routes.Vercel,
                    serverResolved: true,
                });
            }
        }

        resolveServer();

        return () => controller.abort();
    }, []);

    return state;
}
